import type { RouteObject } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import Services from '@/pages/services/page';
import HowItWorks from '@/pages/how-it-works/page';
import About from '@/pages/about/page';
import ForSuppliers from '@/pages/for-suppliers/page';
import Contact from '@/pages/contact/page';
import PersonalMatch from '@/pages/enquire/personal-match/page';
import EventRescue from '@/pages/enquire/event-rescue/page';
import DreamTeam from '@/pages/enquire/dream-team/page';
import SupplierApply from '@/pages/apply/page';
import PrivacyPolicy from '@/pages/legal/privacy-policy/page';
import CustomerTerms from '@/pages/legal/customer-terms/page';
import WebsiteTerms from '@/pages/legal/website-terms/page';
import SupplierInsights from '@/pages/supplier-insights/page';
import SupplierInsightsThankYou from '@/pages/supplier-insights/thank-you/page';
import FreeEventChecklist from '@/pages/free-event-checklist/page';
import FreeEventChecklistThankYou from '@/pages/free-event-checklist/thank-you/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'services', element: <Services /> },
      { path: 'how-it-works', element: <HowItWorks /> },
      { path: 'about', element: <About /> },
      { path: 'for-suppliers', element: <ForSuppliers /> },
      { path: 'contact', element: <Contact /> },
      { path: 'enquire/personal-match', element: <PersonalMatch /> },
      { path: 'enquire/event-rescue', element: <EventRescue /> },
      { path: 'enquire/dream-team', element: <DreamTeam /> },
      { path: 'apply', element: <SupplierApply /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
      { path: 'customer-terms', element: <CustomerTerms /> },
      { path: 'website-terms', element: <WebsiteTerms /> },
      { path: 'supplier-insights', element: <SupplierInsights /> },
      { path: 'supplier-insights/thank-you', element: <SupplierInsightsThankYou /> },
      { path: 'free-event-checklist', element: <FreeEventChecklist /> },
      { path: 'free-event-checklist/thank-you', element: <FreeEventChecklistThankYou /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;